/**
 * Global Member Nav
 * Visible to logged-in users.
 */
$(document).on("turbo:load", function () {
  var $memberNav = $("#member-nav");

  // Toggle submenus
  $memberNav.on("click tap", ".menu-item-has-children > a", function (e, options = {}) {
    if ($(this).data("behavior") === "block_link_click_and_instead_open_menu") {
      if ($(event.target).data("behavior") === "handle_link_click_instead_of_opening_menu") {
        return true; // let them click the link
      }
    }
    else {
      if ($(this).attr("href") !== "#" && !options.fromManualHack) {
        return true; // let them click the link
      }
    }

    e.preventDefault();

    // First, close search, the admin menus, or any sibling menus that are curerntly open
    $(".search-form.is-open").removeClass("is-open").fadeOut(200);

    $(".dropdown.open").removeClass("open");

    $(this)
      .parent(".menu-item-has-children")
      .siblings(".menu-item-has-children.-is-open")
      .children("a.active")
      .removeClass("active");
    $(this)
      .parent(".menu-item-has-children")
      .siblings(".menu-item-has-children.-is-open")
      .removeClass("-is-open");

    // Then toggle this menu specifically
    $(this).parent(".menu-item-has-children").toggleClass("-is-open");
    $(this).toggleClass("active");

    $(".mobile-menu-toggle-block > .btn.mobile-menu-toggle").toggleClass("is-open");

    return false;
  });

  // Toggle Member Nav Site Search
  $(".member-nav-site-search").on(
    "click tap",
    ".member-nav-search-toggle",
    function (e) {
      e.preventDefault();

      deactivateAdminLinks("search");

      var $searchForm = $(this).next(".search-form");
      var $searchField = $(".search-field");

      // Toggle the search form class to open or close it
      $searchForm.toggleClass("is-open").fadeToggle(200);

      // If the field is in focus, then we are probably closing the menu when we click this again
      // so we should drop focus from this input
      if ($searchField.is(":focus")) {
        $searchField.blur();
      } else {
        // Otherwise set focus on it
        $searchField.focus();
      }
    }
  );

  $(".custom-dropdown-link").on(
    "click tap",
    function (e) {
      e.preventDefault();

      var $link = $(this);
      var $linkId = $link.attr("id");

      // Close inactive submenus and/or search bar
      if ($linkId === "adminMenu") {
        deactivateAdminLinks("admin");
      } else if ($linkId === "organization") {
        deactivateAdminLinks("organization");
      } else if ($linkId === "user-admin-menu") {
        deactivateAdminLinks("userAdmin");
      }

      var $submenu = $link.next($(".custom-dropdown-submenu"));
      
      var isOpen = JSON.parse($link.attr("aria-expanded"));
      $link.attr("aria-expanded", !isOpen);
      
      if (isOpen) {
        $link.removeClass("active");
        $submenu.removeClass("show-submenu").addClass("hide-submenu");
      } else {
        $link.addClass("active");
        $submenu.removeClass("hide-submenu").addClass("show-submenu");
      }
    }
  );

  // Determine which submenus to close based on which submenu the user is opening
  const deactivateAdminLinks = (link) => {
    if (link === "search") {
      closeAdminMenu();
      closeOrgsMenu();
      closeUserAdminMenu();
    } else if (link === "admin") {
      closeOrgsMenu();
      closeUserAdminMenu();
      closeSearch();
    } else if (link === "organization") {
      closeAdminMenu();
      closeUserAdminMenu();
      closeSearch();
    } else if (link === "userAdmin") {
      closeAdminMenu();
      closeOrgsMenu();
      closeSearch();
    } else { 
      closeAdminMenu();
      closeOrgsMenu();
      closeUserAdminMenu();
      closeSearch();
    }
  }

  const closeAdminMenu = () => {
    $("#adminMenu")
      .attr("aria-expanded", false)
      .next(".custom-dropdown-submenu")
      .removeClass("show-submenu")
      .addClass("hide-submenu");
  }

  const closeOrgsMenu = () => {
    $("#organizationMenu")
      .attr("aria-expanded", false)
      .next(".custom-dropdown-submenu")
      .removeClass("show-submenu")
      .addClass("hide-submenu");
  }

  const closeUserAdminMenu = () => {
    $("#user-admin-menu")
      .attr("aria-expanded", false)
      .next(".custom-dropdown-submenu")
      .removeClass("show-submenu")
      .addClass("hide-submenu");
  }

  const closeSearch = () => {
    $(".member-nav-site-search .search-form").removeClass("is-open");
  }

  // Close search when we open dropdowns
  $("#logout-section .custom-dropdown-link").on("click tap", function () {
    $(".search-form").removeClass("is-open").fadeOut(200);
  });

  $("body").on("click tap", function () {
    $("#member-nav .menu-item-has-children a").removeClass("active");
    $("#member-nav .menu-item-has-children").removeClass("-is-open");
    $(".mobile-menu-toggle-block > .btn.mobile-menu-toggle").removeClass("is-open");
  });

  $(".mobile-menu-toggle-block > .btn.mobile-menu-toggle").on("click tap", function(event) {
    event.preventDefault();
    event.stopPropagation();

    if ($('.mobile-my-vrsa-menu li[data-target="top_level_dropdown"]').hasClass("-is-open")) {
      $('.mobile-my-vrsa-menu li[data-target="top_level_dropdown"]').removeClass("-is-open");
      $('.mobile-my-vrsa-menu li[data-target="top_level_dropdown"]').removeClass("-was-opened-by-main-menu");
      $('.mobile-my-vrsa-menu li[data-target="top_level_dropdown_link"]').removeClass("active");
      $(this).removeClass("is-open");
    }
    else {
      $('.mobile-my-vrsa-menu li[data-target="top_level_dropdown"]').addClass("-is-open");
      $('.mobile-my-vrsa-menu li[data-target="top_level_dropdown"]').addClass("-was-opened-by-main-menu");
      $('.mobile-my-vrsa-menu li[data-target="top_level_dropdown_link"]').addClass("active");
      $(this).addClass("is-open");
    }
  });

  // TODO - dirty hack to achieve hover menus using the clicks we already have in place
  $("div.member-menu-wrapper > ul#menu-member-nav > li.menu-item-has-children > a").on("mouseenter", function() {
    $(this).trigger("click", { fromManualHack: true });
  });

  $("div.member-menu-wrapper > ul#menu-member-nav").on("mouseleave", function() {
    $("div.member-menu-wrapper > ul#menu-member-nav > li.menu-item-has-children > a.active").trigger("click", { fromManualHack: true });
  })
});
